import { render } from "./LabOption_Component.vue?vue&type=template&id=5d34d101"
import script from "./LabOption_Component.vue?vue&type=script&lang=js"
export * from "./LabOption_Component.vue?vue&type=script&lang=js"

import "./LabOption_Component.vue?vue&type=style&index=0&id=5d34d101&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__